import React, { useEffect } from 'react';

import { useGetCard } from '@vlabs/api/artemy/client';
import type { CardId } from '@vlabs/api/artemy/model';
import validate from '@vlabs/shared/validators';
import { Page, Control } from '@vlabs/uikit';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import st from './EditCardUserDataForm.module.sass';
import type { TPointCardUserData } from '../../types';

export interface EditCardUserDataFormProps {
  cardId: CardId;
  onSubmit: (values: TPointCardUserData) => void;
  onCancel?: VoidFunction;
}

export function EditCardUserDataForm({
  cardId,
  onSubmit,
  onCancel = undefined,
}: EditCardUserDataFormProps): React.JSX.Element {
  const { t } = useTranslation();
  const getCard = useGetCard(cardId);
  const form = useForm<TPointCardUserData>({ defaultValues: { fio: '' } });
  const { reset } = form;

  useEffect(() => {
    reset({ fio: (getCard.data?.user_data?.fio as string) ?? '' });
  }, [getCard.data, reset]);

  return (
    <form onSubmit={form.handleSubmit(onSubmit)}>
      <Page
        className={st.Page}
        title={t('card-page:edit card.title') as unknown as string}
      >
        <div className={st.InputWrapper}>
          <Control.Input
            id="fio"
            label={t('card-page:edit card.input label')}
            {...form.register('fio', {
              required: validate.required(),
              maxLength: validate.maxLength(128),
            })}
            errors={form.formState.errors}
          />
        </div>

        <div className={st.ModalFooter}>
          <div className={st.ButtonWrapper}>
            <Control.Button
              className={st.Button}
              data-testid="submitCardEditButton"
              type="submit"
            >
              {t('shared:форма.submit')}
            </Control.Button>
          </div>

          {!!onCancel && (
            <div className={st.ButtonWrapper}>
              <Control.Button
                className={st.Button}
                data-testid="closeCardEditButton"
                kind="secondary"
                onClick={onCancel}
                variant="outlined"
              >
                {t('shared:кнопка.отмена')}
              </Control.Button>
            </div>
          )}
        </div>
      </Page>
    </form>
  );
}
